import { createSelector } from 'reselect';
import {
  AlertAndKey,
  AlertsResponse,
  AlertNotificationsResponse,
  AlertNotificationAndKey,
} from '@fullstory/client-api';
import { FetchAlertDataResponse } from '@fullstory/proto/fs/services/amber';
import { AppState } from '../../types';

export const getAlerts = createSelector(
  (state: AppState): AlertsResponse | null => state.alerts.alerts.data,
  (alertsData: AlertsResponse | null): AlertAndKey[] => alertsData?.Alerts ?? [],
);

export const getAlertData = createSelector(
  (state: AppState): FetchAlertDataResponse | null => state.alerts.alertData.data,
  (alertData: FetchAlertDataResponse | null): FetchAlertDataResponse.Point[] =>
    alertData?.values ?? [],
);

export const getAlertNotifications = createSelector(
  (state: AppState): AlertNotificationsResponse | null => state.alerts.notifications.data,
  (alertNotificationsData: AlertNotificationsResponse | null): AlertNotificationAndKey[] =>
    alertNotificationsData?.Notifications ?? [],
);
